import React, { useState, useEffect, useReducer } from "react";
import BookingsHeader from "./BookingsHeader";
import BookingsListItem from "../../components/BookingsListItems/BookingsListItems";
import LoadingOverlay from "react-loading-overlay";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
const { request, handleErrors } = require("../../services/helpers")
const inputClass =
    "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";
const labelClass =
    "block tracking-wide text-black font-display text-sm leading-5 font-medium mb-2";

const SET_ORGANISATION_TYPE = "SET_ORGANISATION_TYPE";
const SET_FORM_LOADING = "SET_FORM_LOADING";
const GET_ORGANISATION_SUCCESS = "GET_ORGANISATION_SUCCESS";
const GET_ORGANISATION_FAILURE = "GET_ORGANISATION_FAILURE";
const GET_ALL_ORGANISATIONS_SUCCESS = "GET_ALL_ORGANISATIONS_SUCCESS";
const GET_ALL_ORGANISATIONS_FAILURE = "GET_ALL_ORGANISATIONS_FAILURE";
const GET_MEMBERSHIPS_SUCCESS = "GET_MEMBERSHIPS_SUCCESS";
const GET_MEMBERSHIPS_FAILURE = "GET_MEMBERSHIPS_FAILURE";
const SELECT_MEMBERSHIP_SUCCESS = "SELECT_MEMBERSHIP_SUCCESS";
const SELECT_MEMBERSHIP_FAILURE = "SELECT_MEMBERSHIP_FAILURE";


const initialState = {
    organisationType: null,
    organisation: null,
    loading: false,
    error: "",
    memberships: [],
    organisationList: [],
    membershipSelected: null
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FORM_LOADING:
            return {
                ...state,
                loading: action.payload === false ? action.payload : true,
                error: "",
            };
        case SET_ORGANISATION_TYPE:
            return {
                ...state,
                organisationType: action.payload,
            };
        case GET_ORGANISATION_SUCCESS: {
            return {
                ...state,
                organisation: action.payload,
                membershipSelected: null,
                // error: action.payload,
                loading: false,
            };
        }
        case GET_ORGANISATION_FAILURE: {
            return {
                ...state,
                error: action.payload,
                loading: false,
                organisation: null,
            };
        }
        case GET_ALL_ORGANISATIONS_SUCCESS:
            return {
                ...state,
                organisationList: action.payload,
                loading: false,
            };

        case GET_ALL_ORGANISATIONS_FAILURE: {
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        }

        case GET_MEMBERSHIPS_SUCCESS: {
            return {
                ...state,
                loading: false,
                memberships: action.payload,
            };
        }

        case GET_MEMBERSHIPS_FAILURE: {
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        }

        case SELECT_MEMBERSHIP_SUCCESS: {
            return {
                ...state,
                loading: false,
                membershipSelected: action.payload,
            };
        }

        case SELECT_MEMBERSHIP_FAILURE: {
            return {
                ...state,
                error: action.payload,
                loading: false,
                membershipSelected: null,
            };
        }

        default:
            return state;
    }
};


const BookingsDashboard = (props) => {

    const [date, setDate] = useState(Date());
    const [endDate, setEndDate] = useState(Date());
    const [location, setLocation] = useState("");
    // const [membershipId, setMembershipId] = useState("");
    const [inputValue, setInputValue] = React.useState('');
    const [loadData, setLoadData] = useState(false);
    const [data, setData] = useState([]);
    const [creditsUsed, setCreditsUsed] = useState();

    const [state, dispatch] = useReducer(reducer, initialState);
    const { loading, error, organisationList, memberships, membershipSelected } = state;

    const toggleOrganisationType = (type) => {
        dispatch({
            type: SET_ORGANISATION_TYPE,
            payload: type,
        });
    };

    // GET_ALL_ORGANISATIONS
    useEffect(() => {
        let active = true;
        (async () => {
            dispatch({ type: SET_FORM_LOADING });
            try {
                // throw new Error("help");
                const res = await request.get("/organizations");
                if (!Array.isArray(res.data))
                    throw new Error("Something went wrong. Please reload the page.");
                if (active) {
                    dispatch({
                        type: GET_ALL_ORGANISATIONS_SUCCESS,
                        payload: res.data,
                    });
                }
            } catch (e) {
                if (active) {
                    dispatch({
                        type: GET_ALL_ORGANISATIONS_FAILURE,
                        payload: handleErrors(e),
                    });
                }
            }
        })();
        return () => {
            active = false;
        };
    }, []);

    // GET_ALL_MEMBERSHIPS_OF_THE_ORGANISATION
    useEffect(() => {
        if (state.organisation) {
            (async () => {
                try {
                    dispatch({ type: SET_FORM_LOADING });
                    const res = await request.get(
                        `/memberships/?organizationId=${state.organisation._id}`
                    );
                    dispatch({
                        type: GET_MEMBERSHIPS_SUCCESS,
                        payload: res.data,
                    });
                } catch (e) {
                    dispatch({
                        type: GET_MEMBERSHIPS_FAILURE,
                        payload: handleErrors(e),
                    });
                }
            })();
        }
    }, [state.organisation]);

    // useEffect(() => {
    //     if (memberships && memberships.length > 0) {
    //         setMembershipId(memberships[0]._id);
    //     }
    // }, [memberships]);

    const handleOrganisationSelect = async (event, value) => {
        // Step 1: Load and display the organisation details
        // Step 2: List all memberships: [], for the selected organisation
        dispatch({ type: GET_ORGANISATION_SUCCESS, payload: value });
        setData([]);
        setCreditsUsed(0);
        setInputValue('');
    };

    const handleMembershipSelection = async (event, value) => {
        if (value?._id) {
            dispatch({ type: SELECT_MEMBERSHIP_SUCCESS, payload: value._id });
            setInputValue(value.name);
        }
    };

    const locations = [
        { name: '2gethr@HSR', value: '2gethr@HSR' },
        { name: '2gethr@ORR', value: '2gethr@ORR' },
        { name: 'All', value: 'all' },
    ]

    const getData = async (queryData) => {
        // const axios = require('axios');

        const {
            dateData,
            endDate,
            locationData,
            membershipIdData
        } = queryData;

        // let orgStartDate = moment(dateData, 'Do MMM YYYY').toDate();
        let formattedStartDate = moment(dateData).startOf('day').subtract(6, 'hours');
        let formattedEndDate = moment(endDate).startOf('date');

        const res = await request.get(
            `bookings?location=${locationData}&membership=${membershipIdData}&startDate=${formattedStartDate}&endDate=${formattedEndDate}`
        );

        const { resultttt, totalCost } = res.data;

        setData(resultttt);
        setCreditsUsed(totalCost);
        setLoadData(true);


    }

    useEffect(() => {
        if (date && endDate && location && membershipSelected) {
            getData({ dateData: date, endDate, locationData: location, membershipIdData: membershipSelected });
        }
    }, [date, endDate, location, membershipSelected]);

    const listRoomBookings = () => {
        return (
            <div>
                <div className="bg-white shadow overflow-hidden sm:rounded-lg px-4 py-5 sm:px-6">
                    <h3 className="leading-6 font-medium text-gray-900 ">Booking Summary</h3>
                    <div class="border-t border-gray-200">
                        {/* <p className="mt-1 max-w-2xl text-sm text-gray-600">From {moment(date).format('MMMM Do YYYY')}</p>
                        <p className="mt-1 max-w-2xl text-sm text-gray-600">To   {moment(endDate).format('MMMM Do YYYY')}</p> */}
                        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-500">
                                Date Range
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {moment(date).format('MMMM Do YYYY')} <h3> - </h3> {moment(endDate).format('MMMM Do YYYY')}
                            </dd>
                        </div>

                        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-500">
                                Total credits used :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {creditsUsed}
                            </dd>
                        </div>
                        <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-500">
                                Cost of each credit :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                100
                            </dd>
                        </div>
                        <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                            <dt class="text-sm font-medium text-gray-500">
                                Total cost :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {creditsUsed * 100}
                            </dd>
                        </div>
                    </div>
                </div>
                <div>
                    {data.map((item) => {
                        return (
                            <div key={item._id} className="py-8 md:px-0 px-4  md:w-3/4 w-full">
                                <div className="border-b-2 border-gray-300 pb-2">
                                    <h3 className="font-normal text-lg">Room: {item.roomId.name} || {moment(item.dateToBook).format("MMMM Do YYYY")} || {item.roomId.conference__cost_in_credits} Credits/Hour</h3>
                                </div>
                                <div className="pt-4">
                                    < BookingsListItem
                                        bookings={item}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }

    return (
        <LoadingOverlay
        >
            <div className="py-8 lg:px-16 px-8 flex flex-col flex-1 bg-formBackground mb-16">
                <BookingsHeader />
                <div className="mt-12">
                    <span className="text-base leading-5 text-gray-500">
                        Show Bookings For
                    </span>
                    {/* Filter Inputs */}
                    <div className="mt-3">
                        <div className="md:flex md:space-x-8">
                            <div className="md:w-1/2 w-full mb-6">
                                <label
                                    className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                                    htmlFor="center-location"
                                >
                                    Select Existing Organisation
                                </label>
                                <Autocomplete
                                    options={organisationList || []}
                                    getOptionLabel={(option) =>
                                        option?.name || option?.registeredEmail
                                    }
                                    name="organisationSearch"
                                    onChange={
                                        handleOrganisationSelect
                                    }
                                    renderInput={(params) => (
                                        <Input
                                            params={params}
                                            textFieldProps={{
                                                placeholder: "Select An Organisation",
                                            }}
                                        />
                                    )}
                                />
                            </div>
                            <div className="md:w-1/2 w-full mb-6">
                                <label
                                    className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                                    htmlFor="center-location"
                                >
                                    Select Membership
                                </label>
                                <Autocomplete
                                    options={memberships || []}
                                    getOptionLabel={(option) =>
                                        option?.name || option?.registeredEmail
                                    }
                                    name="membershipSearch"
                                    onChange={
                                        handleMembershipSelection
                                    }
                                    renderInput={(params) => (
                                        <Input
                                            params={params}
                                            textFieldProps={{
                                                placeholder: "Select Membership",
                                            }}
                                        />
                                    )}
                                    inputValue={inputValue}
                                    onInputChange={(event, newInputValue) => {
                                        setInputValue(newInputValue);
                                    }}
                                />
                            </div>

                            <div className="md:w-1/2 w-full mb-6">
                                <label className={labelClass} htmlFor="booking-date">
                                    Start Date
                                </label>

                                <input
                                    className={inputClass}
                                    id="booking-date"
                                    placeholder="Start date"
                                    type="date"
                                    name="booking_date"
                                    onChange={(data) => {
                                        setDate(data.target.value);
                                    }}
                                />
                            </div>

                            <div className="md:w-1/2 w-full mb-6">
                                <label className={labelClass} htmlFor="end-date">
                                    End Date
                                </label>

                                <input
                                    className={inputClass}
                                    id="end-date"
                                    placeholder="End date"
                                    type="date"
                                    name="End_date"
                                    onChange={(data) => {
                                        setEndDate(data.target.value);
                                    }}
                                />
                            </div>
                            <div className="md:w-1/2 w-full mb-6">
                                <label
                                    className="block truncate tracking-wide text-black font-display text-sm leading-5 font-medium mb-2"
                                    htmlFor="center-location"
                                >
                                    Center Location
                                </label>
                                <Autocomplete
                                    options={locations || []}
                                    getOptionSelected={(option, value) => option.name === value.name}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(_, data) => {
                                        setLocation(data.value);
                                    }}
                                    renderInput={(props) => (
                                        <div
                                            className="flex items-center"
                                            ref={props.InputProps.ref}
                                        >
                                            <div className="w-full">
                                                <input
                                                    style={{
                                                        width: "100%",
                                                        padding: "10px",
                                                        borderRadius: "4px",
                                                        borderColor: "#cbd5e0",
                                                        border: "1px solid #cbd5e0",
                                                        outline: "none",
                                                    }}
                                                    defaultValue={location}
                                                    type="text"
                                                    placeholder="Select a Center"
                                                    {...props.inputProps} />
                                            </div>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        {
                            loadData ? (
                                listRoomBookings()
                            ) : (
                                <span className="text-base leading-5 text-gray-500">
                                    Not loaded
                                </span>
                            )
                        }
                    </div>

                </div>
            </div>
        </LoadingOverlay >

    );
}

export default BookingsDashboard;

const Input = ({ params, textFieldProps }) => (
    <div className="flex items-center" ref={params.InputProps.ref}>
        <div className="w-full">
            <input
                style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "4px",
                    borderColor: "#cbd5e0",
                    border: "1px solid #cbd5e0",
                    outline: "none",
                }}
                type="text"
                {...params.inputProps}
                {...textFieldProps}
            />
        </div>
    </div>
);